import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import deleteIcon from 'images/icons/invite/delete.svg';
import Tooltip from 'components/ui/Tooltip';
import { useContext } from 'components/ResourceNotes/Context';

export default function Index({ note }) {
  const { dispatch, actions, state } = useContext();

  const deleteNote = (e) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this note?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'BUTTON') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin" style="width: 26px"></i>';
          actions.destroy(dispatch, state.resourceType, state.resourceId, note.id);
        }
      },
    );
  };

  return (
    <>
      <Button
        bsStyle="link"
        className="pl0 pr0"
        onClick={(e) => deleteNote(e)}
        data-tip="Delete"
      >
        <img src={deleteIcon} alt="delete" />
      </Button>

      <Tooltip />
    </>
  );
}

Index.propTypes = {
  note: PropTypes.object.isRequired,
};
